"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var vue_1 = __importDefault(require("vue"));
var vuex_1 = __importDefault(require("vuex"));
var apply_validate_1 = __importDefault(require("./modules/app/apply_validate"));
var apply_exec_1 = __importDefault(require("./modules/app/apply_exec"));
var price_get_1 = __importDefault(require("./modules/app/price_get"));
vue_1.default.use(vuex_1.default);
exports.default = new vuex_1.default.Store({
    modules: {
        apply_validate: apply_validate_1.default,
        apply_exec: apply_exec_1.default,
        price_get: price_get_1.default,
    }
});
